import { FormInstance } from 'antd';

import { CardExplorer, ExplorerInputDescription } from '@page/explorer/explorer.style';

import { Input } from '@atom/form/input/input';
import { Text, Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { Form } from '@form/common.style';
import { isString } from '@util/data/is-exist';

interface ExplorerParamsProps {
  form: FormInstance;
  fields: Record<string, any>[];
}

export const ExplorerParams = ({ form, fields }: ExplorerParamsProps) => (
  <CardExplorer>
    <Title color={ColorEnum.Black100} level={5} mb={8} weight={400}>
      Params
    </Title>
    <Form form={form} layout='vertical'>
      {fields.map((field) => {
        const { label = field.key, placeholder = field.key, description } = field.description ?? {};
        return (
          <Form.Item
            key={field.key}
            name={['params', field.key]}
            label={
              <>
                <Text color={ColorEnum.Black30} level='s'>
                  {label}
                </Text>
                {isString(description) && <ExplorerInputDescription>{description}</ExplorerInputDescription>}
              </>
            }
          >
            <Input placeholder={placeholder} />
          </Form.Item>
        );
      })}
    </Form>
  </CardExplorer>
);
